<template>
    <div>
        <router-view></router-view>
        <ejs-toast ref='toastRef' id='globalToast' :position='position'></ejs-toast>
        <div id="mainSpinner"></div>
    </div>
</template>

<script>
    import Vue from "vue";
    import i18n, { loadLocaleMessages } from "@/i18n";
    import { ToastPlugin, Toast } from "@syncfusion/ej2-vue-notifications";
    import checkUIPermissions from './common/UIPermissions'
    import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
    import * as signalR from "@microsoft/signalr";
    import urls from './common/urls';
    import { registerLicense } from '@syncfusion/ej2-base';
    import authToken from './common/authToken';
    import apis from './common/network';

    Vue.use(ToastPlugin);
    registerLicense('Ngo9BigBOggjHTQxAR8/V1NAaF5cWWVCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWX5ccnRTRGhYVEZzWkA=');


    export default {
      
        name: 'App',
        data() {
            return {
                position: { X: 'Right', Y: 'Bottom' },
                hubConnection: HubConnection
            }
        },
        created: function () {
            this.hubConnection = new signalR.HubConnectionBuilder()
                .withUrl(`${urls.apiBaseUrl}messageHub`)
                .build();
            this.hubConnection.on("broadcastMessage", this.broadcastCallBack);
            this.hubConnection
                .start()
                .then(() => {
                    console.log("hub started");
                    this.hubConnection.invoke(
                        "broadcastMessage",
                        "_SYSTEM_",
                        "ja" + " JOINED"
                    );
                })
                .catch(e => {
                    console.error(
                        `An error occurred while connecting to operations hub. Details ${e}`
                    );
                });
        },
        methods: {
            broadcastCallBack: function (name, message) {
                if (!message) return;
                if (name == this.$store.state.loggedInUserEmail) {
                    let fullMessage = name + " " + message;
                    let messageInfo = { title: 'Info', content: fullMessage, cssClass: 'e-toast-info' };
                    this.$root.$emit('showToast', messageInfo);
                } else {
                    return;
                }
            },

        },
        mounted() { 
            var token = authToken.get();
            if (!token.length) {
                apis.navigateToLogin(window.location.pathname);
            }
            checkUIPermissions();
            loadLocaleMessages(i18n.locale);
            this.$root.$on('showToast', (e) => {
                this.$refs.toastRef.show(e);
            });
        }
    }
</script>

<style lang="scss">
    @import 'assets/scss/style';
    @import 'assets/scss/bootstrap5';
</style>
<style>
    @import 'assets/scss/bootstrap5.css';
    @import "../node_modules/@syncfusion/ej2-pdfviewer/styles/bootstrap5.css";
    /*@import "../node_modules/@syncfusion/ej2-vue-maps/styles/material.css";*/
</style>
